import React, {useState} from 'react';
import {Card, CardContent, Grid, Typography, } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import ElementoDelCard from 'components/card/ElementoDelCard';
import Card64Image from 'components/card64Image';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { tipoDeMedio } from 'constantes/globalsStates';
import { functions } from 'constantes';
import TablaPersonalizada from 'components/TablaPersonalizada';

const DetalleDelMedio = ({ datosGeneralesDelTarifario, tipoDelMedio}) => {
  const classes = styles();
  const {canalDeTercero, nombre, detallesDeMedioDeComunicacion, logo, audienciaPorEdad, } = datosGeneralesDelTarifario;


  const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', abrirAlerta: false, });
  const [encabezadoTabla] = useState([ { title: 'Rango de edades', field: 'rangoDeEdades.rango'}]);

  const validarTipoDeTarifario = () => {
    switch(tipoDeMedio[tipoDelMedio]) {
        case 1: return ( <>
            <ElementoDelCard title={'Nombre del canal:'} label={nombre || ""}/>
            {/* <ElementoDelCard title={'Número del canal:'} label={numeroDelCanal}/> */}
          </>
        )
        case 2: return ( <>
            <ElementoDelCard title={'Nombre de la radio:'} label={nombre || ""}/>
            <ElementoDelCard title={'Estación:'} label={datosGeneralesDelTarifario.estacion}/>
            <ElementoDelCard title={'Frecuencia:'} label={datosGeneralesDelTarifario?.frecuencia ? "FM" : "AM"}/>
          </>
        )
        case 3: return ( <>
            <ElementoDelCard title={'Nombre del medio:'} label={nombre || ""}/>
            <ElementoDelCard title={'Circulación:'} label={datosGeneralesDelTarifario?.tipoDeCirculacionDeMedioEscrito?.descripcion || ""}/>
            <ElementoDelCard title={'Distribución:'} label={datosGeneralesDelTarifario?.tipoDeDistribucionDeMedioEscrito?.descripcion || ""}/>
          </>
        )
        default: return <Typography>No hay información para mostrar</Typography>
    }
  }

  const validarTipoDeTarifario2 = () => {
    switch(tipoDeMedio[tipoDelMedio]) {
        case 1:
        case 2: return ( <ElementoDelCard title={'¿Se transmite en un tercero?:'} label={canalDeTercero ? "SI" : "NO" }/> )
        case 3: return ( <ElementoDelCard title={'Tipo de medio:'} label={datosGeneralesDelTarifario?.tipoDeMedioEscrito?.descripcion || ""}/> )
        default: return <Typography></Typography>
    }
  }

  const cerrarRespuesta = (_, reason) => {
    if (reason === 'clickaway') {return}
    changeDataResponse('error', '', false)
  };

  const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, abrirAlerta = false) =>  setDatosDeRespuesta({tipoDeAlerta, mensajeDeAlerta, abrirAlerta});

  const {tipoDeAlerta, mensajeDeAlerta, abrirAlerta} = datosDeRespuesta;

  return (
    <Card className={classes.root}>
        <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={abrirAlerta} handClose={cerrarRespuesta}/>
        <CardContent>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12}>
              <TituloConIcono title={"Datos del medio"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid item xs={12}>
                {validarTipoDeTarifario()}
                <ElementoDelCard title={'Descripción:'} label={detallesDeMedioDeComunicacion?.descripcion || ""}/>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              {logo ? (
                  <Card64Image label={"Logo"} image={logo} title={"Logo"} src={logo} showTitle={false} showInMovil={true}/>
              ): <Typography variant="h5" component="div" align='center'>No Adjunto el logo <br/> </Typography>}
            </Grid>
            <Grid item xs={12}>
              <TituloConIcono title={"Especificación técnicas"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <ElementoDelCard title={'Correo para recepción de materiales:'} label={detallesDeMedioDeComunicacion?.correoDeRecepcion || ""}/>
              <ElementoDelCard title={'Días de anticipación para entregar el material a pautar:'} label={detallesDeMedioDeComunicacion?.diasDeAnticipacion || ""}/>
              <ElementoDelCard title={'Especificaciones técnicas del material:'} label={detallesDeMedioDeComunicacion?.especTecnicasDelMaterial || ""}/>
              {validarTipoDeTarifario2()}
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container justify="center" alignItems="center">
                <Grid item xs={12}>
                  <TituloConIcono title={"Perfil de la audiencia"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                  <ElementoDelCard title={'Hombres:'} label={`${detallesDeMedioDeComunicacion?.porcentajeAudienciaHombres} %` || ""}/>
                  <ElementoDelCard title={'Mujeres:'} label={`${detallesDeMedioDeComunicacion?.porcentajeAudienciaMujeres} %` || ""}/>
                  <ElementoDelCard title={'Nivel socieconómico alto:'} label={`${detallesDeMedioDeComunicacion?.nivelSocioEconomicoAlto} %` || ""}/>
                  <ElementoDelCard title={'Nivel socieconómico medio:'} label={`${detallesDeMedioDeComunicacion?.nivelSocioEconomicoMedio} %` || ""}/>
                  <ElementoDelCard title={'Nivel socieconómico bajo:'} label={`${detallesDeMedioDeComunicacion?.nivelSocioEconomicoBajo} %` || ""}/>
                </Grid>
                <Grid item xs={12}>
                  <TituloConIcono title={"Rating y alcance"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                  <ElementoDelCard title={'Rating:'} label={detallesDeMedioDeComunicacion?.ratingDelMedio || ""}/>
                  <ElementoDelCard title={'Alcance en personas:'} label={detallesDeMedioDeComunicacion?.alcanceEnPersonas || ""}/>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <TituloConIcono title={"Rango de Edades"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <TablaPersonalizada
                  data={functions.ordenarArreglo(audienciaPorEdad, 'id')}
                  title={"Listado de rangos de edades"}
                  header={encabezadoTabla}
                  addRegister={undefined}
              />
            </Grid>
          </Grid>
        </CardContent>
    </Card>
  );
}

export default DetalleDelMedio;